(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["videowise-product-widget"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.dynamic-product-widget').forEach(initWidget);
  });

  function cleanText(str) {
    if (!str) return '';
    return str.toString().toLowerCase().replace(/[^a-z0-9]/g, '').trim();
  }

  function initWidget(widget) {
    const sectionWrapper = widget.closest('[id^="shopify-section-"]') || widget;

    const tabs = sectionWrapper.querySelectorAll('.shade-tabs-vw .shade-tab-vw');
    const swatches = sectionWrapper.querySelectorAll('.option-value-input');
    const mediaDivs = sectionWrapper.querySelectorAll('[vw-data-category]');
    const selects = sectionWrapper.querySelectorAll("select[name*='option'], select.single-option-selector");

    // Lista de variante ascunse e scopată DOAR la această secțiune (atribut pe
    // wrapper), nu pe window — așa cealaltă secțiune cu același switch nu o preia.
    const hiddenAttr = widget.getAttribute('data-hidden-variants') || '';
    let processedHiddenVariants = hiddenAttr
      .split(',')
      .map(v => cleanText(v))
      .filter(v => v !== '');

    let activeCategory = 'all';
    let activeSwatchValue = sectionWrapper.querySelector('.option-value-input:checked')?.value || '';

    /* HIDE SWATCHES - Modificat cu selector de clasă strictă */
    function hideForbiddenSwatches() {
      if (!processedHiddenVariants.length) return;

      swatches.forEach(swatch => {
        const swatchValClean = cleanText(swatch.value);
        
        // 🔒 Căutăm DOAR părintele care are clasa unică din snippet-ul nostru Videowise
        const parent = swatch.closest('.vw-local-swatch');
        
        if (parent && sectionWrapper.contains(parent)) {
          const shouldHide = processedHiddenVariants.some(hiddenTarget => {
            return hiddenTarget.includes(swatchValClean) || swatchValClean.includes(hiddenTarget);
          });

          if (shouldHide) {
            parent.style.setProperty('display', 'none', 'important');
            parent.classList.add('vw-hidden-variant');
          }
        }
      });
    }

    /* DISABLE SWATCHES - Modificat cu selector de clasă strictă */
    function disableHiddenSwatches() {
      if (!processedHiddenVariants.length) return;

      swatches.forEach(swatch => {
        const swatchValClean = cleanText(swatch.value);
        const parent = swatch.closest('.vw-local-swatch'); // 🔒 Doar clasa noastră locală
        
        if (parent && sectionWrapper.contains(parent)) {
          const shouldHide = processedHiddenVariants.some(hiddenTarget => {
            return hiddenTarget.includes(swatchValClean) || swatchValClean.includes(hiddenTarget);
          });

          if (shouldHide) {
            // Dacă ai nevoie vreodată de opacitate, o poți decomenta aici, dar acum este sigură
            // parent.style.setProperty('pointer-events', 'none', 'important');
            // parent.style.setProperty('opacity', '0.35', 'important');
          }
        }
      });
    }

    /* HIDE SELECT OPTIONS */
    function hideForbiddenProductFormOptions() {
      if (!processedHiddenVariants.length || selects.length === 0) return;

      selects.forEach(select => {
        if (sectionWrapper.contains(select)) {
          Array.from(select.options).forEach(opt => {
            const optValClean = cleanText(opt.textContent);
            const shouldHide = processedHiddenVariants.some(hiddenTarget => {
              return hiddenTarget.includes(optValClean) || optValClean.includes(hiddenTarget);
            });

            if (shouldHide) {
              opt.remove(); 
            }
          });
        }
      });
    }

    /* AUTO SELECT FIRST VISIBLE */
    function autoSelectFirstVisibleSwatch() {
      return; // Menținem funcția goală așa cum ai cerut, ca să nu schimbe singură widgetul din dreapta
    }

    /* HIDE MEDIA */
    function hideForbiddenMedia() {
      if (!processedHiddenVariants.length) return;

      mediaDivs.forEach(div => {
        if (sectionWrapper.contains(div)) {
          const mediaValClean = cleanText(div.getAttribute('vw-data-category') || '');
          const shouldHide = processedHiddenVariants.some(hiddenTarget => {
            return hiddenTarget.includes(mediaValClean) || mediaValClean.includes(hiddenTarget);
          });

          if (shouldHide) {
            div.classList.add("vw-force-hidden");
          }
        }
      });
    }

    // Categoriile din taburi (fără "All"), curățate, sortate descrescător după
    // lungime — ca un titlu "Light/Medium - X" să fie atribuit corect categoriei
    // "Light/Medium", nu "Light".
    const tabCats = Array.from(tabs)
      .map(t => cleanText(t.dataset.category))
      .filter(c => c && c !== 'all')
      .sort((a, b) => b.length - a.length);

    // Categoria unui widget = cel mai lung prefix de categorie care se potrivește
    // cu vw-data-category (titlul blocului are forma "CATEGORIE - NUME NUANȚĂ").
    function mediaCategory(div) {
      const c = cleanText(div.getAttribute('vw-data-category') || '');
      return tabCats.find(cat => c.startsWith(cat)) || '';
    }

    /* LAZY HYDRATE — injectează embed-ul Videowise al unui widget abia când e
       afișat prima dată, ca Videowise să-l inițializeze la cerere (nu pe toate
       odată). Primul widget e deja live (nu are <template>). */
    function hydrateWidget(div) {
      if (!div || div.dataset.vwHydrated) return;
      div.dataset.vwHydrated = '1';
      const tpl = div.querySelector('template.vw-lazy-embed');
      if (!tpl) return; // primul widget: deja randat live
      const frag = tpl.content.cloneNode(true);
      // Scripturile clonate dintr-un <template> NU se execută la inserare — le
      // recreăm ca elemente noi ca browserul să le ruleze (și Videowise să se init-eze).
      frag.querySelectorAll('script').forEach(function (oldScript) {
        const s = document.createElement('script');
        Array.prototype.forEach.call(oldScript.attributes, function (a) {
          s.setAttribute(a.name, a.value);
        });
        s.textContent = oldScript.textContent;
        oldScript.parentNode.replaceChild(s, oldScript);
      });
      tpl.replaceWith(frag);
    }

    /* UPDATE MEDIA VISIBILITY - arată un SINGUR widget */
    function updateMediaVisibility() {
      // Numele nuanței fără undertone-ul din paranteză (ex. "Haze (Cool)" -> "Haze").
      const swatchClean = cleanText((activeSwatchValue || '').split('(')[0]);
      const tabClean = cleanText(activeCategory); // "All" -> "all"

      // Candidați: media din secțiune, neascunse de hide_variants și care
      // aparțin tab-ului activ (sau toate dacă tab-ul e "all").
      const candidates = Array.from(mediaDivs).filter(div => {
        if (!sectionWrapper.contains(div)) return false;
        if (div.classList.contains('vw-force-hidden')) return false;
        if (tabClean === 'all') return true;
        return mediaCategory(div) === tabClean;
      });

      // Alegem un singur widget: cel care se potrivește cu swatch-ul selectat
      // (după numele nuanței din titlu), altfel primul candidat disponibil.
      let target = null;
      if (swatchClean) {
        target = candidates.find(div => {
          const c = cleanText(div.getAttribute('vw-data-category') || '');
          return c.includes(swatchClean);
        });
      }
      if (!target) target = candidates[0] || null;

      // Hidratează (încarcă embed-ul Videowise) doar widgetul care urmează să fie vizibil.
      if (target) hydrateWidget(target);

      mediaDivs.forEach(div => {
        const forbidden = div.classList.contains('vw-force-hidden');
        div.classList.toggle('hidden', forbidden || div !== target);
      });
    }

    /* UPDATE SWATCH VISIBILITY */
    function updateSwatchVisibility() {
      swatches.forEach(swatch => {
        const parent = swatch.closest('.vw-local-swatch'); // 🔒 Doar clasa noastră locală
        if (parent && sectionWrapper.contains(parent)) {
          parent.style.display = '';

          const variantCategory = cleanText(swatch.getAttribute('data-shade-category-variant') || '');
          const currentTabClean = cleanText(activeCategory);

          const matchesCategory = (currentTabClean === 'all' || variantCategory === currentTabClean);

          if (!matchesCategory) {
            parent.style.display = 'none'; 
          }
        }
      });

      hideForbiddenSwatches();
      disableHiddenSwatches();
    }

    /* TAB CLICK EVENTS */
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        tabs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        activeCategory = this.dataset.category;
        updateSwatchVisibility();
        updateMediaVisibility();
      });
    });

    /* SWATCH CHANGE EVENTS */
    swatches.forEach(swatch => {
      swatch.addEventListener('change', function() {
        activeSwatchValue = this.value;
        updateMediaVisibility();
      });
    });

    /* RUN INITIALIZATION */
    setTimeout(function() {
      hideForbiddenSwatches();
      hideForbiddenProductFormOptions();
      disableHiddenSwatches();
      hideForbiddenMedia();
      updateSwatchVisibility();
      updateMediaVisibility();
    }, 150);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
